module.exports = __webpack_public_path__ + "img/protection.08880e99.svg";